import { render } from "./PopUpComponent.vue?vue&type=template&id=056c1b1c&scoped=true"
import script from "./PopUpComponent.vue?vue&type=script&lang=js"
export * from "./PopUpComponent.vue?vue&type=script&lang=js"

import "./PopUpComponent.vue?vue&type=style&index=0&id=056c1b1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056c1b1c"]])

export default __exports__